import React, { useState } from 'react';
import { Layout, Menu, Dropdown, Avatar, Tag, Space, Typography, Grid, Drawer, Button, theme } from 'antd';
import { 

  LogoutOutlined, 
  DashboardOutlined, 
  TeamOutlined,
  SettingOutlined,
  BarChartOutlined,
  CrownOutlined,
  MenuOutlined,
  WarningOutlined,
  AuditOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import ThemeControl from '../Common/ThemeControl';

import logoMenu from '../../assets/6.png';

const { Header, Content, Sider } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    {
      key: '/admin/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => {
        navigate('/admin/dashboard');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/users',
      icon: <TeamOutlined />,
      label: 'Usuarios',
      onClick: () => {
        navigate('/admin/users');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/plans',
      icon: <SettingOutlined />,
      label: 'Planes',
      onClick: () => {
        navigate('/admin/plans');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/stats',
      icon: <BarChartOutlined />,
      label: 'Estadísticas',
      onClick: () => {
        navigate('/admin/stats');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/fiscal-admins',
      icon: <AuditOutlined />,
      label: 'Fiscal-admins',
      onClick: () => {
        navigate('/admin/fiscal-admins');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/efirma',
      icon: <SafetyCertificateOutlined />,
      label: 'e.firma',
      onClick: () => {
        navigate('/admin/efirma');
        setDrawerVisible(false);
      },
    },
    {
      key: '/admin/error-logs',
      icon: <WarningOutlined />,
      label: 'Logs de Errores',
      onClick: () => {
        navigate('/admin/error-logs');
        setDrawerVisible(false);
      },
    },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <CrownOutlined />,
      label: user?.username,
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header
        style={{
          padding: screens.lg ? '0 24px' : '0 12px',
          height: screens.lg ? '64px' : '50px',
          lineHeight: screens.lg ? '64px' : '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: token.colorBgContainer,
          color: token.colorText,
          width: '100%',
          flexShrink: 0,
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          boxShadow: token.boxShadowTertiary,
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', height: '100%' }}
          onClick={() => navigate('/admin/dashboard')}
        >
          <img src={logoMenu} alt="Mi Factura" style={{ height: screens.lg ? '40px' : '28px' }} />
        </div>

        <div style={{ flex: 1 }} />

        <Space size={screens.lg ? 12 : 8}>
          {/* La etiqueta identifica el perfil en un panel con permisos totales.
              En móvil ocupa demasiado. */}
          {screens.md && (
            <Tag icon={<CrownOutlined />} color="gold">
              ADMIN
            </Tag>
          )}

          <ThemeControl />

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
            <Avatar
              style={{ backgroundColor: token.colorPrimary, cursor: 'pointer' }}
              icon={<CrownOutlined />}
            />
          </Dropdown>

          {!screens.lg && (
            <Button
              type="text"
              icon={<MenuOutlined style={{ fontSize: '20px' }} />}
              onClick={() => setDrawerVisible(true)}
            />
          )}
        </Space>
      </Header>

      {/* Drawer Móvil */}
      <Drawer
        title="Admin Menu"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={250}
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ padding: '16px', borderBottom: `1px solid ${token.colorSplit}`, marginBottom: '8px' }}>
          <Space>
            <Avatar style={{ backgroundColor: token.colorPrimary }} icon={<CrownOutlined />} />
            <Text strong>{user?.username}</Text>
          </Space>
          <div style={{ marginTop: '8px' }}>
            <Tag color="gold">ADMIN</Tag>
          </div>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={[
            ...menuItems,
            { type: 'divider' },
            {
              key: 'logout',
              icon: <LogoutOutlined />,
              label: 'Cerrar Sesión',
              danger: true,
              onClick: handleLogout
            }
          ]}
          style={{ border: 'none' }}
        />
      </Drawer>

      <Layout style={{ flex: 1 }}>
        {screens.lg && (
          <Sider
            width={240}
            style={{
              backgroundColor: token.colorBgContainer,
              borderRight: `1px solid ${token.colorSplit}`,
            }}
          >
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              items={menuItems}
              style={{ border: 'none', height: '100%' }}
            />
          </Sider>
        )}

        <Content
          style={{
            padding: screens.lg ? '24px' : '12px',
            backgroundColor: token.colorBgLayout,
            width: '100%',
            overflow: 'auto',
          }}
        >
          <div
            style={{
              maxWidth: '1400px',
              margin: '0 auto',
              backgroundColor: token.colorBgContainer,
              borderRadius: '8px',
              padding: screens.lg ? '24px' : '12px',
              boxShadow: token.boxShadowSecondary,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>

      <Footer />
    </Layout>
  );
};

export default AdminLayout;
